import { render, staticRenderFns } from "./AR-PH-Notice.vue?vue&type=template&id=54365968&scoped=true&"
import script from "./AR-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./AR-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./AR-PH-Notice.vue?vue&type=style&index=0&id=54365968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54365968",
  null
  
)

export default component.exports